<template>
  <el-card
    class="contact-card"
    :body-style="{ height: '100%', 'background-color': 'var(--nxt-color-lightest-blue)'}">
    <div class="contact-card__body">
      <div>
        <font-awesome-icon
          :icon="['fal', 'question-circle']"
          size="2x"
          class="contact-card__cards__icon"
        />
      </div>
      <h3 class="contact-card__body__h3 center-v-h">
        {{ $t('home.descriptifsCards.aQuestion') }}
      </h3>
      <p class="contact-card__body__text to-upper-case center-v-h">
        {{ $t('home.descriptifsCards.contactUs') }}
      </p>
      <div class="contact-card__body__button">
        <router-link :to="{ name: 'contact' }">
          <el-button
            type="primary">
            {{ $t('home.descriptifsCards.contact') }}
          </el-button>
        </router-link>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'contactCard',
};
</script>

<style scoped lang="scss">
.contact-card {
  margin-bottom: 20px;
  border-radius: 0;
  border: none;
  @include breakpoint(tablet) {
    border-radius: 4px;
    margin: 0;
  }
  &__body {
    position: relative;
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-bottom: 0;
    font-size: 18px;
    height: 100%;
    &__h3 {
      margin-top: 10px;
      margin-bottom: 0;
      height: 60px;
    }
    &__text {
      margin: 10px 0;
      font-size: 16px;
      flex: 1 1;
    }
  }
}
</style>
